// extracted by mini-css-extract-plugin
export default {"PreviewMobile":"PreviewMobile_PreviewMobile__woqEO"};